import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MapComponent } from '../map/map.component';
import { Subject } from 'app/shared/models/subject';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-show-map',
  templateUrl: './show-map.component.html',
  styleUrls: ['./show-map.component.scss']
})
export class ShowMapComponent {
  public _subject: Subject = null;
  public enableGeoLocation: boolean = environment.enableGeoLocation;

  @Input() backgroundColor;
  @Input() set subject(val: Subject) {
    this._subject = val;
  }

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

  showMapButton(): boolean {
    if (this.enableGeoLocation === false || !this._subject) 
      return false;
    
    if (this._subject.hasLocation === true && this._subject.latitude && this._subject.longitude)
      return true;

    if (this._subject.subjectLinks && this._subject.subjectLinks.length > 0)
    {          
      var rc = this._subject.subjectLinks.filter(link => {
        return (link.linkedSubject?.latitude  && link.linkedSubject?.longitude);
      });
      if (rc.length>0)
        return true;
    }

    if (this._subject?.linkedLocations && this._subject?.linkedLocations?.length > 0)
    {
      var rc2 = this._subject?.linkedLocations?.filter(link=>{
        return (link?.subjectId && link?.latitude && link?.longitude);          
      });
      if (rc2.length>0)
        return true;
    }
      
    return false;    
  }

  showMap() {
    // Show Popup screen         
    if (this._subject.hasLocation === true) {
      this.dialog.open(MapComponent, {
        data: {
          subject: this._subject,
        },
      });
    }
    else if (this._subject.linkedLocations && this._subject.linkedLocations.length > 0) {
      this.dialog.open(MapComponent, {
        data: {
          subjectList: this._subject.linkedLocations,
        },
      });
    }
    else if (this._subject.subjectLinks && this._subject.subjectLinks.length > 0) {
      this.dialog.open(MapComponent, {
        data: {
          subjectList: this._subject.subjectLinks.flatMap(x => x.linkedSubject),
        },
      });
    }
  }
}
